import _ from "lodash";
import React from "react";
import { Helmet } from "react-helmet";
import { IonButton, IonLoading, IonSearchbar, IonToast } from "@ionic/react";

import "./TimeKeepingPatientsList.scss";
import * as services from "../../services";
import { MBDialog } from "../../components/MBDialog/MBDialog";
import { MBAppointmentList } from "../../components/MBAppointmentList/MBAppointmentList";
import { MBContainer } from "../../components/MBContainer/MBContainer";
import { MBProps, UserType } from "../../interface";
import {
  HospitalDoctorAppointmentsView,
  HospitalServiceAppointmentsView,
  TimeKeeping,
} from "../../models";
import { APPOINTMENT_STATUS_TYPES, MBCOLORS } from "../../constants/config";
import { MSGS_COMMON } from "../../constants/messages";

class TimeKeepingPatientsList extends React.Component<MBProps> {
  state = {
    loading: false,
    error: "",
    successConfirmArrival: false,

    searchQuery: "",
    doctorAppointments: [] as HospitalDoctorAppointmentsView[],
    serviceAppointments: [] as HospitalServiceAppointmentsView[],
    filteredAppointments: [] as (
      | HospitalDoctorAppointmentsView
      | HospitalServiceAppointmentsView
    )[],
    consolidatedResourceList: [] as (
      | HospitalDoctorAppointmentsView
      | HospitalServiceAppointmentsView
    )[],
  };

  componentDidMount = () => {
    this.getHospitalDoctorAppointments();
    this.getHospitalServiceAppointments();
  };

  getHospitalDoctorAppointments = async () => {
    const { authUser } = this.props;
    try {
      await services.getDoctorAppointmentsPatientOrHospital(
        "hospital",
        (authUser.userDetails as TimeKeeping).hospitalId,
        (hospitalDoctorAppointments, error) => {
          if (!error) {
            this.setState({
              doctorAppointments: _.filter(
                hospitalDoctorAppointments,
                (appointment) => _.isEmpty(appointment.appointmentStatus)
              ),
              loading: false,
            });
            setTimeout(() => {
              this.applyFilters();
            }, 200);
          }
        },
        new Date()
      );
    } catch (error) {
      console.log("Error -- ", error);
    }
  };

  updateAppointmentStatus = async (
    appointmentId: string,
    isDoctorAppointment: boolean
  ) => {
    try {
      this.setState({
        loading: true,
      });
      const { authUser } = this.props;
      await services.pushAppointmentProgress(
        appointmentId,
        isDoctorAppointment,
        APPOINTMENT_STATUS_TYPES.arrived.id,
        authUser.uid,
        authUser.userType as UserType
      );
      this.setState({ successConfirmArrival: true, loading: false });
    } catch (error) {
      console.log("ERROR???", error);
      this.setState({ error, loading: false });
    }
  };

  getHospitalServiceAppointments = async () => {
    const { authUser } = this.props;

    try {
      await services.getServiceAppointmentsPatientOrHospital(
        "hospital",
        (authUser.userDetails as TimeKeeping).hospitalId,
        (hospitalServiceAppointments, error) => {
          if (!error) {
            this.setState({
              serviceAppointments: _.filter(
                hospitalServiceAppointments,
                (appointment) => _.isEmpty(appointment.appointmentStatus)
              ),
            });
            setTimeout(() => {
              this.applyFilters();
            }, 200);
          }
        },
        new Date()
      );
    } catch (error) {
      console.log("Error -- ", error);
    }
  };
  applyFilters = () => {
    const { searchQuery, doctorAppointments, serviceAppointments } = this.state;

    const consolidatedResourceList: (
      | HospitalDoctorAppointmentsView
      | HospitalServiceAppointmentsView
    )[] = _.filter(
      [...(doctorAppointments || []), ...(serviceAppointments || [])],
      (appointment) => {
        let isValid = true;
        const formattedSearchQuery = searchQuery.trim().toLowerCase();

        if (
          !_.isEmpty(searchQuery) &&
          !appointment.patientDetails.firstName
            .trim()
            .toLocaleLowerCase()
            .includes(formattedSearchQuery)
        ) {
          isValid = false;
        }
        return isValid;
      }
    );

    this.setState({
      consolidatedResourceList: _.sortBy(consolidatedResourceList, "distance"),
    });
  };

  render = () => {
    const {
      searchQuery,
      consolidatedResourceList,
      successConfirmArrival,
      loading,
      error,
    } = this.state;
    console.log("CONSOLIDATED", consolidatedResourceList);
    return (
      <>
        <Helmet>
          <title>MedBook - Hospital - Schedule</title>
        </Helmet>
        <MBContainer {...this.props} activePage="search-patients">
          <div className="time-keeping-patient-list-container">
            <div className="time-keeping-patient-list-search-card-container">
              <IonSearchbar
                mode="ios"
                placeholder="Search keyword here..."
                value={searchQuery}
                onIonChange={(e) =>
                  this.setState({ searchQuery: e.detail.value })
                }
                className="time-keeping-patient-list-search-input mb-body ion-no-margin ion-no-padding ion-text-start"
              />

              <IonButton
                className="time-keeping-patient-list-search-submit mb-body"
                color={MBCOLORS.primary}
                mode="ios"
                disabled={loading}
                onClick={this.applyFilters}
              >
                Search
              </IonButton>
            </div>
            <MBAppointmentList
              mode="patient-list"
              appointmentData={consolidatedResourceList}
              onClickView={(appointmentId, isDoctorAppointment) => {
                this.updateAppointmentStatus(
                  appointmentId,
                  isDoctorAppointment
                );
              }}
              onClickCancel={() => {}}
            />
          </div>
        </MBContainer>

        <IonLoading
          translucent={true}
          mode="ios"
          isOpen={loading}
          message={MSGS_COMMON.loading}
        />

        <IonToast
          isOpen={!_.isEmpty(error)}
          message={error}
          duration={2000}
          onDidDismiss={() => {
            this.setState({
              error: "",
            });
          }}
          color={MBCOLORS.danger}
        />

        <MBDialog
          isOpen={successConfirmArrival}
          title="Patient Arrival has been confirmed"
          message="Please assist the patient to their appointment."
          icon="success"
          onDidDismiss={() => {
            this.setState({
              successConfirmArrival: false,
            });
          }}
        />
      </>
    );
  };
}

export default TimeKeepingPatientsList;
